import { apiFetch } from "@/lib/api";

/**
 * Los datos de contacto de Consultek: lo que el documento de cotización imprime
 * en la banda del pie, en la portada y en la contraportada.
 *
 * ES UNA FILA ÚNICA, así que el endpoint no lleva id (`/api/datos-empresa`) y
 * no hay alta ni baja — solo leer y guardar.
 */
export interface DatosEmpresa {
  /** `null` en una instalación nueva, antes de que alguien cargue los datos. */
  email_contacto: string | null;
  telefono: string | null;
  /**
   * SIN esquema ("www.consultek.cl"), que es como lo imprime el documento real.
   * Guardarlo con `https://` obligaría a recortarlo al imprimir.
   */
  sitio_web: string | null;
  direccion: string | null;
  /** El Código Único Territorial de la comuna de la oficina. */
  comuna_codigo: string | null;

  /* Los tres de abajo son de SOLO LECTURA: los deriva el servidor desde el
     registro oficial de comunas. No se editan ni viajan al guardar — si se
     capturaran, podrían terminar contradiciendo al código. */
  comuna: string | null;
  region: string | null;
  /** La abreviatura que imprime el documento: "RM" para la Metropolitana. */
  abreviatura_region: string | null;
}

/** Lo que el formulario manda: los cinco campos que se editan, y nada más. */
export interface DatosEmpresaInput {
  email_contacto: string;
  telefono: string;
  sitio_web: string;
  direccion: string;
  comuna_codigo: string;
}

export async function fetchDatosEmpresa(): Promise<DatosEmpresa> {
  const respuesta = await apiFetch<{ data: DatosEmpresa }>("/api/datos-empresa");
  return respuesta.data;
}

export async function guardarDatosEmpresaRequest(
  input: DatosEmpresaInput,
): Promise<DatosEmpresa> {
  const respuesta = await apiFetch<{ data: DatosEmpresa }>("/api/datos-empresa", {
    method: "PUT",
    body: JSON.stringify(input),
  });
  return respuesta.data;
}
